import { render, staticRenderFns } from "./StudentCategoriesEdit.vue?vue&type=template&id=08064cf4"
import script from "./StudentCategoriesEdit.vue?vue&type=script&lang=ts"
export * from "./StudentCategoriesEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports